import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
const Image = (props) => (
  <Icon viewBox="0 0 33 30" {...props}>
    <g>
      <path d="M5.245 25.336l6.891-6.89 2.297 4.593 6.89-9.187 6.891 11.484H5.245zM8.461 4.664c1.837 0 3.445 1.608 3.445 3.445s-1.608 3.446-3.445 3.446-3.445-1.608-3.445-3.446S6.624 4.664 8.46 4.664zM25.687.07H7.313C3.408.07.422 3.056.422 6.961v16.078c0 3.905 2.986 6.89 6.89 6.89h18.375c3.905 0 6.891-2.985 6.891-6.89V6.961c0-3.905-2.986-6.89-6.89-6.89z"
      />
    </g>
  </Icon>
);
/*eslint-enable */

export default Image;



// WEBPACK FOOTER //
// ./~/wix-style-react/src/Icons/dist/components/Image.js